import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Areas from "@/pages/Areas";
import AreaPage from "@/pages/AreaPage";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import EpcHub from "@/pages/EpcHub";
import EpcTown from "@/pages/EpcTown";
import CsHub from "@/pages/CsHub";
import CsTown from "@/pages/CsTown";
import HomeSurveys from "@/pages/HomeSurveys";
import ScrollToHash from "@/components/site/ScrollToHash";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToHash />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/areas" element={<Areas />} />
          <Route path="/areas/:slug" element={<AreaPage />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/epc" element={<EpcHub />} />
          <Route path="/epc/:slug" element={<EpcTown />} />
          <Route path="/condition-surveys" element={<CsHub />} />
          <Route path="/condition-surveys/:slug" element={<CsTown />} />
          <Route path="/home-surveys" element={<HomeSurveys />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
